import { ORDER_STATUSES } from '../constants/appConstants';

export const SPECIAL_REQUEST_FULFILL_ORDER_STATUSES = Object.freeze({
  READY: 'ready',
  MEMO: 'memo',
});

export const DEFAULT_SPECIAL_REQUEST_SETTINGS = {
  fulfillOrderStatus: SPECIAL_REQUEST_FULFILL_ORDER_STATUSES.READY,
};

export function resolveSpecialRequestSettings(companyOrSettings) {
  const raw = companyOrSettings?.specialRequestSettings ?? companyOrSettings ?? {};
  const status = raw.fulfillOrderStatus;

  return {
    fulfillOrderStatus: Object.values(SPECIAL_REQUEST_FULFILL_ORDER_STATUSES).includes(status)
      ? status
      : DEFAULT_SPECIAL_REQUEST_SETTINGS.fulfillOrderStatus,
  };
}

export function mapSpecialRequestSettingsToForm(company) {
  return {
    specialRequestSettings: resolveSpecialRequestSettings(company),
  };
}

export function buildSpecialRequestSettingsSavePayload(form) {
  return {
    specialRequestSettings: {
      fulfillOrderStatus: resolveSpecialRequestSettings(form).fulfillOrderStatus,
    },
  };
}

export function resolveFulfillOrderItemStatus(companyOrSettings) {
  const { fulfillOrderStatus } = resolveSpecialRequestSettings(companyOrSettings);
  return fulfillOrderStatus === SPECIAL_REQUEST_FULFILL_ORDER_STATUSES.MEMO
    ? ORDER_STATUSES.MEMO
    : ORDER_STATUSES.READY;
}
